module.exports = __webpack_public_path__ + "static/media/app.c84d1f59.png";